import { Row, Col } from 'antd';

import rslogo from './../../static/img/rs_logo.png';
import vtlogo from './../../static/img/vt_logo.png';
import bppylogo from './../../static/img/bppy_logo.png';
import imlogo from './../../static/img/im_logo.jpg';
import sbdtlogo from './../../static/img/sbdt_logo.jpg';

const MainPage = () => {

  return (
    <>
  {/*
      <Row gutter={[10,10]} justify="space-around" align="middle" style={{ backgroundColor: '#fff', paddingTop: '40px', paddingBottom: '20px' }}>
        <Col span={12} md={12} sm={24} xs={24}>
        </Col>
        <Col span={12} md={12} sm={24} xs={24}>
          <img src={chart} style={{ height : '300px', width: 'auto' }} alt='CHART'/>
        </Col>
      </Row>
  */}
      <Row justify="space-around" align="middle" style={{ backgroundColor: '#fff', paddingTop: '40px', paddingBottom: '50px', paddingLeft: '20px', paddingRight: '20px' }}>
        <Col span={24} style={{ paddingBottom: '20px' }}>
          <h2 style={{color: '#2e2f5b', fontSize: '36px', fontWeight: '600', letterSpacing: '5px', textAlign: 'center'}}>
            Partneri
          </h2>
        </Col>
        <Col style={{ padding: '10px' }}>
          <img src={rslogo} style={{ height : '50px', width: 'auto' }} alt='RS_TECHNOLOGY'/>
        </Col>
        <Col style={{ padding: '10px' }}>
          <img src={imlogo} style={{ height : '50px', width: 'auto' }} alt='INSTALL_MONT'/>
        </Col>
        <Col style={{ padding: '10px' }}>
          <img src={vtlogo} style={{ height : '70px', width: 'auto' }} alt='VYROBA_TEPLA'/>
        </Col>
        <Col style={{ padding: '10px' }}>
          <img src={bppylogo} style={{ height : '50px', width: 'auto' }} alt='BPPY'/>
        </Col>
        <Col style={{ padding: '10px' }}>
          <img src={sbdtlogo} style={{ height : '50px', width: 'auto' }} alt='SBDT'/>
        </Col>
      </Row>
    </>
  );
}

export default MainPage;